const query = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
const generalEnabled = import.meta.env?.DEV === true || query.get('console') === '1';
const videoEnabled = generalEnabled || query.get('vdecdbg') === '1' || query.get('vdecdebug') === '1';

function write(enabled, level, args) {
  if (!enabled) return;
  const target = globalThis.console;
  if (!target) return;
  const method = typeof target[level] === 'function' ? target[level] : target.log;
  method.apply(target, args);
}

export const runtimeLogger = Object.freeze({
  info: (...args) => write(generalEnabled, 'info', args),
  warn: (...args) => write(generalEnabled, 'warn', args),
  error: (...args) => write(generalEnabled, 'error', args)
});

export const videoLogger = Object.freeze({
  info: (...args) => write(videoEnabled, 'info', args),
  warn: (...args) => write(videoEnabled, 'warn', args),
  error: (...args) => write(videoEnabled, 'error', args)
});
